module.exports = __webpack_public_path__ + "static/media/zam2.ca124ae8.jpg";